import moment from "moment";
import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import { InlineLoading } from "src/components/common";
import { FellowshipsBreadcrumbs } from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as FellowshipActions from "../../../actions/fellowship";
import * as NavigationActions from "../../../actions/navigation";
import * as PagingActions from "../../../actions/pages/pagingPage";
import * as PersonnelActions from "../../../actions/personnel";
import { FormFilterInput } from "../../../components/form";
import {
    RestrictedLayout,
    TruncatedCell,
} from "../../../components/layouts/index";
import { Link } from "../../../components/routing/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { IFormFilter, ITmdState } from "../../../reducers/index";

import "./FellowshipsPage.scss";

interface IFellowshipsPageParams {
    personnelId: number;
}

interface IFellowshipsPageProps extends IRouterProps<IFellowshipsPageParams> {
    // From state
    formFilter: IFormFilter;
    formLength: number;
    personnel: Dtos.Personnel;
    loadingPersonnel: boolean;
    loadPersonnelSuccess: boolean;
    loadPersonnelFailure: boolean;
    loadPersonnelErrorCode: string;

    fellowships: Dtos.Fellowship[];
    loadingFellowships: boolean;
    loadFellowshipsSuccess: boolean;
    loadFellowshipsFailure: boolean;
    loadFellowshipsErrorCode: string;

    personnelId: number;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    lookups: Dtos.Lookup[];

    pageSize: number;
}

interface IFellowshipsPageActions extends IRouterActions {
    clearPersonnel: PersonnelActions.IPersonnelClearActionCreator;
    loadPersonnel: PersonnelActions.IPersonnelLoadByIdActionCreator;

    clearFellowships: FellowshipActions.IFellowshipClearActionCreator;
    loadFellowships: FellowshipActions.IFellowshipsLoadByPersonnelIdActionCreator;

    filter: FellowshipActions.IFellowshipFilterActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type FellowshipsPageProps = IFellowshipsPageProps & IFellowshipsPageActions;

class FellowshipsPage extends React.PureComponent<FellowshipsPageProps, any> {
    constructor(props: FellowshipsPageProps) {
        super(props);

        this.clearFellowships = this.clearFellowships.bind(this);

        this.state = {
            exportToggle: false,
        };
    }

    componentDidMount() {
        const {
            setBreadcrumbs,
            setDrawerItems,
            loadPersonnel,
            loadFellowships,
            personnelId
        } = this.props;
        

        setDrawerItems([]);

        if (personnelId) {
            loadFellowships(personnelId);
            loadPersonnel(personnelId);
            setBreadcrumbs(FellowshipsBreadcrumbs(personnelId));
        }
    }

    componentWillReceiveProps(_nextProps: FellowshipsPageProps) {}

    componentDidUpdate(_prevProps: FellowshipsPageProps, _prevState) {
        const {
            personnelId,
            personnel,
            setBreadcrumbs,
            loadFellowshipsFailure,
            loadPersonnelFailure,
            navigate,
            loadFellowshipsErrorCode,
            loadPersonnelErrorCode,
        } = this.props;

        if (loadFellowshipsFailure) {
            navigate(`/error/${loadFellowshipsErrorCode}`);
        }
        if (loadPersonnelFailure) {
            navigate(`/error/${loadPersonnelErrorCode}`);
        }

        if (personnelId && personnel?.firstName && personnel?.lastName) {
            setBreadcrumbs(
                FellowshipsBreadcrumbs(
                    personnelId,
                    `${personnel.firstName} ${personnel.lastName}`
                )
            );
        }
    }

    componentWillUpdate(_nextProps: FellowshipsPageProps) {}

    componentWillUnmount() {
        this.clearFellowships();
    }

    clearFellowships() {
        this.props.clearFellowships();
        this.props.clearPersonnel();
    }

    showFellowships(): boolean {
        const { loadingFellowships, loadFellowshipsSuccess } = this.props;

        if (!loadingFellowships && loadFellowshipsSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const { loadingPersonnel, loadingFellowships } = this.props;

        return (
            <RestrictedLayout
                anyMatchpermission={Dtos.Permission.FellowshipView}
                loading={loadingPersonnel || loadingFellowships}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const { permissions, personnelId } = this.props;

        const canCreate = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.FellowshipCreate
        );

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Fellowship Manager</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        <FormFilterInput
                            formFilter={this.props.formFilter}
                            onFilter={(e) => this.props.filter(e)}
                        />
                        {canCreate && (
                            <>
                                <Link
                                    className={"btn btn-primary"}
                                    url={`/personnel/${personnelId}/fellowship/create`}
                                >
                                    Create
                                </Link>
                            </>
                        )}
                    </div>
                </div>
                {!this.showFellowships() ? (
                    <InlineLoading absoluteCenter={true} size={50} />
                ) : null}
                {this.showFellowships() ? (
                    <div className="card">
                        <div className="patient-tables">
                            {this.createTable()}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    createTable() {
        const { pageSize, setPageSize, permissions, personnelId, fellowships } =
            this.props;

        if (!fellowships || fellowships?.length == 0) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no fellowships to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = fellowships.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={fellowships}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={
                        showPagination ? pageSize : fellowships.length
                    }
                    pageSize={showPagination ? pageSize : fellowships.length}
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no fellowships to display"
                    resizable={false}
                    onPageSizeChange={(val) => setPageSize(val)}
                    getTdProps={(
                        state,
                        rowInfo: RowInfo,
                        _column,
                        _instance
                    ) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const fellowshipId = rowInfo.original.id;
                                const canView =
                                    AuthenticationHelper.hasPermission(
                                        permissions,
                                        Dtos.Permission.FellowshipView,
                                        fellowshipId,
                                        undefined
                                    );
                                if (canView) {
                                    const url: string = `/personnel/${personnelId}/fellowship/${fellowshipId}/details`;
                                    this.props.navigate(url);
                                }

                                if (handleOriginal) {
                                    handleOriginal();
                                }
                            },
                        };
                    }}
                    defaultSorted={[
                        {
                            id: "dateEntered",
                            desc: true,
                        },
                    ]}
                    columns={[
                        {
                            id: "id",
                            Header: " ",
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => (
                                <FontAwesomeIcon
                                    size="lg"
                                    icon={
                                        FontAwesomeIcons.Duotone.BULIDINGCOLUMNS
                                    }
                                    fixedWidth
                                />
                            ),
                        },
                        {
                            id: "dateStart",
                            Header: "Date Submit. BCT",
                            accessor: "dateStart",
                            maxWidth: 200,
                            Cell: (props) => (
                                <span>
                                    {moment(
                                        props.value ??
                                            props?.original?.dateEntered,
                                        "YYYY-MM-DD HH:mm:ss.SSSSSSS Z"
                                    ).format("DD/MM/YYYY")}
                                </span>
                            ),
                        },
                        {
                            id: "projectTitle",
                            Header: "Project Title",
                            accessor: "projectTitle",
                            Cell: (props) => (
                                <TruncatedCell value={props.value} />
                            ),
                        },
                        {
                            id: "awarded",
                            Header: "Awarded Fellowship",
                            accessor: "awarded",
                            maxWidth: 200,
                            Cell: (props) => (
                                <span>{`${
                                    props.value ? "Approved Fellowship" : ""
                                }`}</span>
                            ),
                        },
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: FellowshipsPageProps
): IFellowshipsPageProps => {
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    let personnel: Dtos.Personnel | undefined = !(
        state.personnel.formData instanceof Array
    )
        ? state.personnel.formData
        : undefined;

    return {
        history: ownProps.history,
        location: ownProps.location,
        match: ownProps.match,
        personnelId: ownProps.match
            ? ownProps.match.params.personnelId
            : undefined!,

        formFilter: state.fellowships.formFilter,
        formLength: state.fellowships.formLength,
        lookups: state.fellowships.lookups,

        personnel: personnel!,
        loadingPersonnel:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Pending,
        loadPersonnelSuccess:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Success,
        loadPersonnelFailure:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Failure,
        loadPersonnelErrorCode: state.personnel.loadState.errorCode,

        fellowships: state.fellowships.formFilteredData!,
        loadingFellowships:
            state.fellowships.loadState &&
            state.fellowships.loadState.status == RequestState.Pending,
        loadFellowshipsSuccess:
            state.fellowships.loadState &&
            state.fellowships.loadState.status == RequestState.Success,
        loadFellowshipsFailure:
            state.fellowships.loadState &&
            state.fellowships.loadState.status == RequestState.Failure,
        loadFellowshipsErrorCode: state.fellowships.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,

        pageSize: state.pagingPage.pageSize,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: FellowshipsPageProps
): IFellowshipsPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadPersonnel: bindActionCreators(
            PersonnelActions.LoadPersonnelById,
            dispatch
        ),
        clearPersonnel: bindActionCreators(PersonnelActions.Clear, dispatch),

        loadFellowships: bindActionCreators(
            FellowshipActions.LoadFellowshipsByPersonnelId,
            dispatch
        ),
        clearFellowships: bindActionCreators(FellowshipActions.Clear, dispatch),

        filter: bindActionCreators(FellowshipActions.Filter, dispatch),

        setPageSize: bindActionCreators(
            PagingActions.PageSizeChanged,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<IFellowshipsPageParams, FellowshipsPageProps>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(FellowshipsPage) as unknown as ComponentType<FellowshipsPageProps>
) as ComponentType<any>;
